import React, { useState, useEffect, useRef } from "react";
import { FaShoppingCart, FaCreditCard } from "react-icons/fa";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import image1 from "../assets/ele2.jpeg";
import image2 from "../assets/ele3.jpg";
import image3 from "../assets/ele4.webp";
import image4 from "../assets/ele-removebg-preview.png";
import staticbanner from "../assets/staticBanner.webp";
import sbanner2 from "../assets/sbanner2.avif";
import sbanner3 from "../assets/sbanner5.webp";
import sbanner4 from "../assets/sbanner6.avif";
import Footer from "../Fotter";
import { ChevronDown, ChevronUp } from "lucide-react";
import video1 from "../assets/video.mp4";
import video2 from "../assets/video2.mp4";
import video3 from "../assets/video3.mp4";
import video4 from "../assets/video4.mp4";
import video5 from "../assets/video5.mp4";
import img1 from "../assets/pic1.png";
import img2 from "../assets/pic2.png";
import img3 from "../assets/pic3.png";
import img4 from "../assets/pic4.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

const TopSellDetails = ({
  videos = [video1, video2, video3, video4, video5],
  image = [img1, img2, img3, img4],
}) => {
  const [images, setImages] = useState(image4);
  const [mainImage, setMainImage] = useState(image4);
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isInCart, setIsInCart] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const rightSectionRef = useRef(null);
  const [isRightScrolled, setIsRightScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (rightSectionRef.current) {
        const { scrollTop, scrollHeight, clientHeight } =
          rightSectionRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 10) {
          setIsRightScrolled(true);
        } else {
          setIsRightScrolled(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const product = {
    title:
      "LG 185 L Direct Cool Single Door 4 Star Refrigerator with Base Drawer and Smart Inverter Compressor & Smart Connect",
    salePrice: 16690,
    regularPrice: 20499,
    category: "Electronics",
    brand: "LG",
    description:
      "The smart inverter compressor of this refrigerator ensures an enhanced performance with its silent and stabiliser-free operations. Its smart connect technology connects this refrigerator to your home inverter in case of power failure. This refrigerator can work on solar energy to save energy and electricity bills. It has a digital panel outside the refrigerator that allows you to set the temperature without opening the door. You can store vegetables in its base stand drawer at room temperature and save space in your kitchen. The toughened glass shelves of this refrigerator allows you to store food in heavy utensils with ease.",
    stock: 10,
    mainiamge: image4,
    images: [image1, image2, image3],
    specifications: {
      modelNumber: "GL-B199OSEY",
      capacity: "185 L",
      energyRating: "4 Star",
      compressorType: "Smart Inverter Compressor",
      defrostingType: "Direct Cool",
      color: "Scarlet Euphoria",
      dimensions: "530 mm x 1140 mm x 650 mm",
      weight: "45 kg",
      material: "Stainless Steel",
      warranty: "1-year comprehensive warranty, 10-year compressor warranty",
    },
    offers: [
      " 10% off up to ₹1,250 on all Axis Bank Credit Cards.",
      " 5% Unlimited Cashback on Flipkart Axis Bank Credit Cards.",
      " Flat ₹500 off on RuPay Credit Card EMI Transactions on orders ",
      "No cost EMI: ₹2,782/month. Standard EMI also available.",
    ],

    ratings: "★★★★★",
    shippingDetails: {
      cost: "₹500",
      estimatedDelivery: "5-7 business days",
    },
    returnPolicy:
      "Product can be returned within 10 days of delivery if unused and in original packaging.",
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const toggleLike = (productId) => {
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = () => {
    setIsInCart(true);
  };

  const handleAddToCartBuy = () => {
    console.log("Proceed to Checkout");
  };

  const toggleDescription = () => {
   
  };
  const faqs = [
    {
      question: "How can I track my order ?",
      answer:
        "Once your order is shipped, you will receive a tracking ID via email and SMS. You can track your order through our Order Tracking Page.",
    },
    {
      question: "What payment methods are accepted ?",
      answer:
        "We accept credit/debit cards, net banking, UPI, and wallets. Cash on delivery (COD) is also available for select locations.",
    },
    {
      question: "Can I return or exchange a product ?",
      answer:
        "Yes, we offer a hassle-free 7-day return and exchange policy. Please visit our Return Policy Page for more details.",
    },
    {
      question: "Is it safe to shop on Fliptriwls ?",
      answer:
        "Absolutely! We use industry-standard encryption and secure payment gateways to ensure the safety of your transactions.",
    },
    {
      question: "Do you offer discounts or coupons ?",
      answer:
        "Yes! We frequently offer discounts and coupons. Subscribe to our newsletter or check our Offers Page for the latest deals.",
    },
    {
      question: "How can I contact customer support ?",
      answer:
        "You can reach us via email at mailto:support@fliptriwls.com or call us at +91 XXXXXXXXXX. Our customer support is available 24/7.",
    },
  ];

  const bannerStyle = {
    width: "90%",
    height: "10%",
    display: "block",
    marginTop: "30px",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const SpecificationsTable = ({ specifications }) => {
    return (
      <div className="p-2 rounded-lg shadow-md mt-2 w-[100%] md:w-[100%] mx-auto">
        <table className="w-full table-fixed min-w-[300px] max-w-md md:max-w-xl border border-gray-300">
          <thead>
            <tr className="bg-gray-800 text-white text-sm md:text-base">
              <th className="py-2 px-3 border-b border-gray-300 text-left w-1/2">
                Key
              </th>
              <th className="py-2 px-3 border-b border-gray-300 text-left w-1/2">
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(specifications).map(([key, value]) => (
              <tr key={key} className="text-gray-400 text-sm md:text-base">
                <td className="px-3 py-2 border-b border-gray-300 truncate w-1/2">
                  {key}
                </td>
                <td className="px-3 py-2 border-b border-gray-300 truncate w-1/2">
                  {value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div
      className="min-h-screen tex-black "
      style={{
        background: "rgb(2,0,36)",
        background:
          "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(43,45,46,1) 0%, rgba(45,50,51,1) 15%, rgba(24,27,28,1) 36%, rgba(21,24,25,1) 59%, rgba(20,21,22,1) 84%)",
      }}
    >
      <h1 className="text-5xl font-bold text-center  text-white leading-[10rem] hidden md:block">
        Product Details
      </h1>

      <div className="flex flex-col md:flex-row mt-4 md:mt-8 sm:mt-10 w-[90%] mx-auto justify-center">
        <div className="w-full md:w-1/2 flex justify-center">
          <div className="sticky top-24 max-h-[calc(100vh-100px)]">
            <div className="relative flex justify-center ">
              <Zoom>
                <img
                  src={mainImage}
                  alt="Product"
                  className="sm:h-96 h-56 mt-4 sm:w-full w-[90%] sm:ml-0 ml-5"
                />
              </Zoom>
            </div>

            <div className="flex justify-center gap-4 mt-4 p-2">
              {product.images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Product image ${index + 1}`}
                  className="w-[100px] h-[100px] object-cover rounded-md border-2 border-gray-300 hover:scale-110 transition-transform cursor-pointer mt-[-13%]"
                  onClick={() => setImages(image)}
                />
              ))}
            </div>
            <div
              className="bottom-0 sm:bottom-4 flex gap-5 justify-center mt-10 fixed 
       left-0 right-0 bg-blue-50 p-4 shadow-lg z-10 sm:relative sm:mb-0 sm:bg-transparent sm:shadow-none
  sm:flex-row sm:justify-center sm:gap-5 sm:p-0 sm:mt-10 sm:z-0"
            >
              <button
                onClick={handleAddToCart}
                className="bg-white border text-black text-lg font-semibold px-3 py-2 rounded-xl shadow-md hover:text-white hover:bg-blue-600 transition duration-300 flex items-center gap-3"
              >
                <FaShoppingCart size={20} />
                <span>{isInCart ? "Added to Cart" : "Add to Cart"}</span>
              </button>
              <button
                onClick={handleAddToCartBuy}
                className="bg-orange-400 text-white text-lg font-semibold py-3 px-6 rounded-xl shadow-md hover:bg-green-600 transition duration-300 flex items-center gap-3"
              >
                <FaCreditCard size={20} />
                <span>Buy Now</span>
              </button>
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2 flex flex-col px-4 sm:px-6 md:px-8">
          <h1 className="text-xl sm:mt-0 mt-3 sm:text-2xl md:text-2xl font-bold text-white">
            {product.title}
          </h1>
          <div className="flex items-center mt-3">
            <span className="text-green-600 text-3xl font-bold">
              ₹{product.salePrice}
            </span>
            <span className="line-through text-red-600 text-lg ml-2">
              ₹{product.regularPrice}
            </span>
          </div>
          <div className="text-xl mt-2">
            <span className="font-bold text-white">Category: </span>
            <span className="text-gray-400">{product.category}</span>
          </div>
          <div className="text-xl mt-2">
            <span className="font-bold text-white">Brand: </span>
            <span className="text-gray-400">{product.brand}</span>
          </div>
          <div className="mt-3">
            <span className="font-bold text-white text-2xl">
              Available offers:{" "}
            </span>
            <ul className=" list-inside text-gray-400 mt-2">
              {product.offers.map((offer, index) => (
                <li key={index}>☞ {offer}</li>
              ))}
            </ul>
          </div>

          <div className="text-xl mt-6">
            <span className="font-bold text-white">Specifications: </span>
            <SpecificationsTable specifications={product.specifications} />
          </div>

          <div className="text-3xl mt-2">
            <span className="font-bold text-white">ratings: </span>
            <span className="text-yellow-400">{product.ratings}</span>
          </div>

          <div className="text-xl mt-4">
            <span className="font-bold text-white">Shipping Details:</span>
            <ul className="text-gray-400 list-disc list-inside mt-2">
              <li>Cost: {product.shippingDetails.cost}</li>
              <li>
                Estimated Delivery: {product.shippingDetails.estimatedDelivery}
              </li>
            </ul>
          </div>

          <h2 className="font-bold text-lg sm:text-2xl mt-5 text-white">
            Description
          </h2>
          <p className="text-gray-400">{product.description}</p>
          <h2 className="font-bold text-lg sm:text-2xl mt-5 text-white">
            Return Policy
          </h2>
          <p className="text-gray-400">{product.returnPolicy}</p>

          {product.stock !== 0 && (
            <div className="mt-5 border-b pb-4">
              <h3 className="font-bold text-lg sm:text-2xl mb-2 text-white">
                Stock Availability:
              </h3>
              <p className="text-lg text-gray-400">{product.stock} in stock</p>
            </div>
          )}
        </div>
      </div>

      <div>
        <img src={staticbanner} alt="Banner" style={bannerStyle} />
      </div>
      <div>
        <img src={sbanner2} alt="Banner" style={bannerStyle} />
      </div>

      <div className="flex justify-center w-full mt-10 overflow-hidden">
        <Swiper
          spaceBetween={10}
          slidesPerView={2}
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 5 },
          }}
          navigation
          modules={[Navigation]}
          className="w-[90%] rounded-lg"
        >
          {videos.length > 0 ? (
            videos.map((video, index) => (
              <SwiperSlide key={index}>
                <video className="w-full h-auto rounded-lg shadow-lg" controls>
                  <source src={video} type="video/mp4" />
                </video>
              </SwiperSlide>
            ))
          ) : (
            <p className="text-gray-500 text-center">No videos available</p>
          )}
        </Swiper>
      </div>

      <div>
        <img src={sbanner3} alt="Banner" style={bannerStyle} />
      </div>

      <div>
        <img src={sbanner4} alt="Banner" style={bannerStyle} />
      </div>

      <div className="flex justify-center w-full mt-10  ">
        <div className="w-[90%] block md:hidden relative">
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            navigation
            modules={[Navigation]}
            className="rounded-lg"
          >
            {image.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img}
                  alt={`Image ${index + 1}`}
                  className="w-full h-[350px] object-cover rounded-lg shadow-lg"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="hidden md:grid grid-cols-2 md:grid-cols-4 w-[90%] gap-0 px-6">
          {image.map((img, index) => (
            <div key={index} className="w-full flex justify-center">
              <img
                src={img}
                alt={`Image ${index + 1}`}
                className="w-[93%] h-[350px] object-cover rounded-lg shadow-lg"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-center mt-8">
        <div className="p-4 text-white w-[90%] text-center">
          <h2 className="text-3xl md:text-5xl font-semibold mb-6 md:mb-8">
            Product Benefits
          </h2>

          <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 list-inside text-lg md:text-xl">
            <li>✔ Good for couples and small families</li>
            <li>✔ Smart Inverter Compressor</li>
            <li>✔ Energy savings up to 45%</li>
            <li>✔ Smart Connect</li>
            <li>✔ Freezer Compartment Features</li>
            <li>✔ Refrigerator Compartment Features</li>
          </ul>
        </div>
      </div>

      <div className="w-[70%] mx-auto mt-10 text-white">
        <h2 className="text-3xl text-green-800 font-bold text-center mb-6">
          Frequently Asked Questions (FAQ)
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-600 pb-4">
              <button
                className="flex justify-between items-center w-full text-left text-xl font-semibold py-1 focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                {openIndex === index ? (
                  <ChevronUp className="text-red-700" />
                ) : (
                  <ChevronDown className="text-red-700" />
                )}
              </button>
              {openIndex === index && (
                <p className="text-gray-400 mt-2 transition-all duration-300">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
      <div
        className="bottom-0 sm:bottom-4 flex gap-5 justify-center mt-10 fixed 
       left-0 right-0 bg-blue-50 p-4 shadow-lg z-10 sm:relative sm:mb-0 sm:bg-transparent sm:shadow-none
        sm:flex-row sm:justify-center sm:gap-5 sm:p-0 sm:mt-10 sm:z-0 sm:hidden block"
      >
        <button
          onClick={handleAddToCart}
          className="bg-white border text-black text-lg font-semibold px-3 py-2 rounded-xl shadow-md hover:text-white hover:bg-blue-600 transition duration-300 flex items-center gap-3"
        >
          <FaShoppingCart size={20} />
          <span>{isInCart ? "Added to Cart" : "Add to Cart"}</span>
        </button>
        <button
          onClick={handleAddToCartBuy}
          className="bg-orange-400 text-white text-lg font-semibold py-3 px-6 rounded-xl shadow-md hover:bg-green-600 transition duration-300 flex items-center gap-3"
        >
          <FaCreditCard size={20} />
          <span>Buy Now</span>
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default TopSellDetails;
